import React, {useMemo} from "react";

import {
    LLBtn2,
    LLPreloader,
    LLProgressBar,
    LLTable,
    WithPopoverCashout,
    BetDetails
} from "../../../components";
import {BetDeleteModal} from "../../../pages/user-profile/components";
import {CashoutModal} from "../../../pages/sport/desktop/right-panel/components";
import {betOddsFormat, formatDate, formatNumber, trans} from "../../../common/utils";
import {CashoutPopupContent} from "./cashout-popup-content";


const BetsList = (
    {
        bets,
        storeItem,
        loading,
        activeBetId,
        noDataText,
        language,
        currency,
        setModal,
        betsError,
        userCanCashout,
        listType = "betHistory",
        isMobile
    }
) => {
    const CashoutField = ({bet} = {}) => useMemo(() => formatNumber(bet.cashout, 2, language, currency), [bet.cashout]);

    const renderCashoutDeleteBtn = (bet) => {
        return (
            (bet.isCanBeDeleted || (userCanCashout && bet.cashout > 0.01)) &&
            <div className="bets-list__cashout-box">
                {bet.isCanBeDeleted ?
                    <>
                        {isMobile ? (
                            <>
                                <LLBtn2
                                    customClasses="bets-list__bet-btn bets-list__bet-btn--delete"
                                    disabled={bet.isDeleting}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setModal({
                                            active: true,
                                            maskBackground: true,
                                            showHeader: false,
                                            currentKey: "custom-content",
                                            customContent: <BetDeleteModal type={listType} id={bet.id}/>
                                        })
                                    }}
                                >
                                    <i className="bets-list__bet-btn-icon--delete doruk-delete-01"/>
                                </LLBtn2>
                            </>
                        ) : (
                            <WithPopoverCashout
                                style={{bottom: "8px"}}
                                popoverClasses="user-bets__popper-delete"
                                placement="top-end"
                                dropDownRole={true}
                                triggeredOnHover={false}
                                betId={bet.id}
                                listType={listType}
                                watch="delete"
                                popoverContent={
                                    <div className="user-bets__popper-delete-message">
                                        <CashoutPopupContent
                                            contentType={"delete"}
                                            type={listType}
                                            id={bet.id}
                                        />
                                    </div>
                                }
                            >
                                <LLBtn2
                                    customClasses="bets-list__bet-btn bets-list__bet-btn--delete"
                                    disabled={bet.isDeleting}
                                >
                                    <i className="bets-list__bet-btn-icon--delete doruk-delete-01"/>
                                </LLBtn2>
                            </WithPopoverCashout>)}
                    </>
                    :
                    (userCanCashout && (bet.cashout > 0.01)) ?
                        <>
                            {isMobile ? (
                                <>
                                    <LLBtn2
                                        customClasses="bets-list__bet-btn"
                                        isLoading={bet.cashoutLoding}
                                        disabled={bet.cashoutLoding}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            storeItem.checkCashout({id: bet.id}).then(() =>
                                                setModal({
                                                    active: true,
                                                    maskBackground: true,
                                                    showHeader: false,
                                                    currentKey: "custom-content",
                                                    customContent: <CashoutModal type={listType} bet={bet}/>
                                                }))
                                        }}
                                    >
                                        {storeItem.isRefreshedBehavior ?
                                            <CashoutField bet={bet}/>
                                            : trans("CashOut")
                                        }
                                    </LLBtn2>
                                </>
                            ) : (
                                <WithPopoverCashout
                                    style={{bottom: "8px"}}
                                    popoverClasses="user-bets__popper-cashout"
                                    placement="top-end"
                                    dropDownRole={true}
                                    triggeredOnHover={false}
                                    betId={bet.id}
                                    listType={listType}
                                    watch="cashout"
                                    popoverContent={
                                        <div className="user-bets__popper-cashout-message">
                                            <CashoutPopupContent
                                                contentType={"cashout"}
                                                type={listType}
                                                bet={bet}
                                            />
                                        </div>
                                    }
                                >
                                    <LLBtn2
                                        customClasses="bets-list__bet-btn"
                                        isLoading={bet.cashoutLoding}
                                        disabled={bet.cashoutLoding}
                                    >
                                        {storeItem.isRefreshedBehavior ?
                                            <CashoutField bet={bet}/>
                                            : trans("CashOut")
                                        }
                                    </LLBtn2>
                                </WithPopoverCashout>
                            )}
                        </>
                        :
                        null
                }
            </div>);
    };

    const betsListConfig = {
        mobileGridProps: {
            key: "id",
            repaintChangesOnly: true,
            dataRowComponent: (e) => {
                const bet = e.data.data;
                return (
                    <>
                        <tr className={`bets-list__bet bets-list__bet--${
                            listType === "betHistory" ? "bet-history" : "active-bets"
                        } ${(activeBetId === bet.id) && !bet.isLoading ? "opened" : ""}`}
                        >
                            <td className="bets-list__bet-collapse"
                                onClick={() => storeItem.setActiveBet(bet.id)}
                            >
                                <div className="bets-list__bet-collapse-head">
                                    <p className="bets-list__bet-title">
                                        <span>{`#${bet.id}`}</span>
                                        <span className="bets-list__bet-time">
                                        {formatDate(bet.dateTime, "DD.MM.YY HH:mm:SS")}
                                    </span>
                                    </p>
                                    <p className="bets-list__bet-collapse-arrow">
                                        {(activeBetId === bet.id) && !bet.isLoading ?
                                            <i className="doruk-close"/>
                                            :
                                            <i className="doruk-dots"/>
                                        }
                                    </p>
                                </div>
                                <div className={`bets-list__bet-money bets-list__bet-money--${bet.statusEn}`}>
                                    <div className="bets-list__bet-money-item bets-list__bet-money-item--with-status">
                                        <span className="bets-list__bet-money-item-inner">
                                            <span className="bets-list__bet-money-item-title">
                                                {trans("Stake")}:
                                            </span>
                                            <span className="bets-list__bet-money-item-value">
                                                {formatNumber(bet.stake, 2, language, currency)}
                                            </span>
                                        </span>
                                        {listType === "betHistory" &&
                                            <span className="bets-list__bet-status">
                                                {trans(bet.status)}
                                            </span>
                                        }
                                    </div>
                                    <div className="bets-list__bet-lower-part">
                                        <div className="bets-list__bet-left-lower-part">
                                            {(listType === "activeBets" && bet.totalOdds) ?
                                                <div className="bets-list__bet-money-item">
                                                <span className="bets-list__bet-money-item-title">
                                                    {trans("TotalOdds")}:
                                                </span>
                                                    <span className="bets-list__bet-money-item-value">
                                                    {betOddsFormat(bet.totalOdds, language)}
                                                </span>
                                                </div>
                                                : null
                                            }
                                            <div className="bets-list__bet-money-item">
                                                <span className="bets-list__bet-money-item-title">
                                                    {trans("Payout")}:
                                                </span>
                                                <span className="bets-list__bet-money-item-value">
                                                    {formatNumber(bet.payout, 2, language, currency)}
                                                </span>
                                            </div>
                                            {bet.paid ?
                                                <div className="bets-list__bet-money-item">
                                                    <span className="bets-list__bet-money-item-title">
                                                        {trans("Paid")}:
                                                    </span>
                                                    <span className="bets-list__bet-money-item-value">
                                                        {formatNumber(bet.paid, 2, language, currency)}
                                                    </span>
                                                </div>
                                                : null
                                            }
                                            { (listType === "betHistory" && bet.bonusTotal) ?
                                                <div className="bets-list__bet-money-item">
                                                    <span className="bets-list__bet-money-item-title">
                                                        {trans("Bonus")}:
                                                    </span>
                                                    <span className="bets-list__bet-money-item-value">
                                                        {formatNumber(bet.bonusTotal, 2, language, currency)}
                                                    </span>
                                                </div>
                                                : null
                                            }
                                        </div>
                                        {renderCashoutDeleteBtn(bet)}
                                    </div>
                                </div>
                                {bet.isLoading &&
                                    <LLProgressBar customClasses="bets-list__bet-progress-bar"/>
                                }
                            </td>
                            <td className="bets-list__bet-collapse-content">
                                {(activeBetId === bet.id && bet.isOpened && !bet.isLoading) &&
                                    (bet.betsDetailsError ?
                                        <div className="bets-list__match bets-list__match--no-data">
                                            {trans(bet.betsDetailsError)}
                                        </div>
                                        :
                                        <BetDetails
                                            bet={storeItem.getBet(activeBetId)}
                                            language={language}
                                            currency={currency}
                                        />)
                                }
                            </td>
                        </tr>
                    </>
                );
            },
            columnHidingEnabled: false,
            showColumnHeaders: false,
            showBorders: false
        },
        mobile: {
            id: "bets-list-table",
            scrollClass: "bets-list__scrollbox",
            customClasses: "bets-list__table"
        }
    };
    betsListConfig.desktopGridProps = betsListConfig.mobileGridProps;
    betsListConfig.desktop = betsListConfig.mobile;

    return (
        <div className={`bets-list ${listType === "betHistory" ? "bets-list--history" : ""}`}>
            {loading ?
                <div className="bets-list__loader-box">
                    <LLPreloader/>
                </div>
                :
                (bets.length && !betsError) ?
                    <LLTable
                        data={bets}
                        customConfig={betsListConfig}
                        size={5}
                        dependenciesForRerender={[activeBetId]}
                    />
                    :
                    <p className="bet-list__no-data-text">
                        {betsError || trans(
                            listType === "activeBets" ?
                                "ACTIVE_BETS_NO_DATA_TEXT"
                                :
                                noDataText
                        )}
                    </p>
            }
        </div>
    );
};

export default BetsList;